module.exports = __webpack_public_path__ + "img/maxLogo.d4d2a9d8.png";